export const SkillTag = ({ skill }) => {
  return (
    <div className="flex gap-1 items-center py-1 pr-1 pl-2.5 bg-white rounded-md border border-zinc-300">
      <span className="gap-1.5 text-sm font-medium leading-5 text-center text-gray-700">
        {skill}
      </span>
      <button className="flex p-1 rounded cursor-pointer">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5"
            stroke="#A4A7AE"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};

export const TechnicalSkills = () => {
  const skills = [
    "User Interface Design",
    "Prototype",
    "Usability Testing",
    "Wireframing",
    "User Experience Design",
  ];

  return (
    <aside className="flex flex-col gap-5 max-md:w-full h-full">
      <div className="flex flex-col flex-1 gap-4 h-full">
        <div className="flex flex-col flex-1 items-start h-full bg-[#FDFDFD] rounded-xl border border-gray-200 ">
          <div className="flex flex-col flex-1 gap-0.5 w-full">
            <h2 className=" gap-4 px-5 pt-3 pb-2 text-sm font-semibold  text-gray-900">
              Technical Skills
            </h2>
            <div className="flex flex-col flex-1 bg-white rounded-xl border border-gray-200 h-full">
              <div className="flex flex-col gap-5 p-5 h-full">
                <div className="flex flex-wrap gap-5">
                  {skills.map((skill, index) => (
                    <SkillTag key={index} skill={skill} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};
